<script>
import { translations, current_lang } from '../../stores.js';
import { onMount } from 'svelte';

let tickets_url = "";

onMount(() => {
    if($current_lang == "FI"){
        tickets_url = "https://www.ticketmaster.fi/artist/pori-jazz-2023-lippuja/96833?language=fi-fi";
    }
    if($current_lang == "EN"){
        tickets_url = "https://www.ticketmaster.fi/artist/pori-jazz-2023-lippuja/96833?language=en-us";
    }
});
</script>
{#if tickets_url != ""}
    <a href="{tickets_url}">
        <div id="buy-tickets-button" role="button">
            <span>{$translations["BUY_TICKETS"][$current_lang]}</span>
        </div>
    </a>
{/if}
<style>
    #buy-tickets-button{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        background-color: var(--theme-color-1);
        padding: 5px 30px;
        border-radius: 96px;
        display: inline-block;
    }
    #buy-tickets-button span{
		font-family: 'futura-pt', Arial;
		color: #fff;
		font-weight: 700;
		text-decoration: none;
		text-transform: none;
        font-size: 1.4rem;
    }
</style>